import {
  AfterViewChecked,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  OnDestroy,
  OnInit
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import {
  MobileAlertService,
  MobileAlertState,
  MobileAlertTone
} from '../../../core/services/mobile-alert.service';

@Component({
  selector: 'app-mobile-alert',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './mobile-alert.component.html',
  styleUrls: ['./mobile-alert.component.css'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MobileAlertComponent implements OnInit, OnDestroy, AfterViewChecked {
  state: MobileAlertState | null = null;
  safeHtml: SafeHtml | null = null;
  inputValue = '';

  private sub?: Subscription;
  private pendingDidOpen = false;

  constructor(
    private readonly mobileAlert: MobileAlertService,
    private readonly sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.sub = this.mobileAlert.state$.subscribe((state) => {
      this.state = state;
      this.inputValue = state?.inputValue ?? '';
      this.safeHtml = state?.html
        ? this.sanitizer.bypassSecurityTrustHtml(state.html)
        : null;
      if (state?.open) {
        this.pendingDidOpen = true;
        document.body.classList.add('mobile-alert-open');
      } else {
        this.pendingDidOpen = false;
        document.body.classList.remove('mobile-alert-open');
      }
    });
  }

  ngAfterViewChecked(): void {
    if (this.pendingDidOpen && this.state?.open) {
      this.pendingDidOpen = false;
      setTimeout(() => this.mobileAlert.notifyOpened(), 0);
    }
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    document.body.classList.remove('mobile-alert-open');
  }

  iconName(tone?: MobileAlertTone): string {
    switch (tone) {
      case 'success':
        return 'checkmark-circle-outline';
      case 'error':
        return 'close-circle-outline';
      case 'warning':
        return 'warning-outline';
      case 'question':
        return 'help-circle-outline';
      default:
        return 'information-circle-outline';
    }
  }

  onBackdrop(event: Event): void {
    if (event.target === event.currentTarget) {
      this.mobileAlert.backdropClick();
    }
  }

  onConfirm(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    void this.mobileAlert.confirmClick(this.inputValue);
  }

  onCancel(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.mobileAlert.cancelClick();
  }
}
